import { render, staticRenderFns } from "./PlaylistSettings.vue?vue&type=template&id=f4fca18a"
import script from "./PlaylistSettings.vue?vue&type=script&lang=js"
export * from "./PlaylistSettings.vue?vue&type=script&lang=js"
import style0 from "./PlaylistSettings.vue?vue&type=style&index=0&id=f4fca18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports